<template lang="pug">
  .answers-task-question
    Info(
      :taskItem="taskItem"
      :systemName="systemName"
      :ddlDate="ddlDateString"
      :answerCreatedAt="answerCreatedAt"
    )
    .answers-task-feedback(v-if="isOpen")
      .answers-task-feedback__input(:style="{alignItems: 'flex-start'}")
        TextArea.answers-task-feedback__input-comment(
          v-model="taskItem.answer.validatingText"
          :error="$v.$dirty && (!taskItem.answer.validatingText && !script)"
          placeholder="Комментарий к заданию от проверяющего"
          :maxlength="4000"
        )

        .answers-task-feedback__input-label(
          v-if="taskItem.question.typeOfTask === 1"
          :class="{'-error-': $v.$dirty && !$v.taskItem.answer.points.required}"
        )
          span.form-item__title
            | Оценка:
          .answers-task-feedback__input-point
            span.main-block__label.answers-card__label
              | Балл:
              span.-main-accent-color-
                |  {{taskItem.answer.points}}
            .answers-task-feedback__input-point-consent(@click="setFixed(true)")
              Icon.validating-card__footer-type(icon="confirm-circle")
            .answers-task-feedback__input-point-no__consent(@click="setFixed(false)")
              Icon.validating-card__footer-type(icon="cancel-circle")

        Input.form-item__title.answers-task-feedback__input-label__input(
          v-else-if="taskItem.question.typeOfTask === 2"
          v-model.number.trim="taskItem.answer.points"
          :title="$v.$dirty && (!$v.taskItem.answer.points.between || !$v.taskItem.answer.points.required) ? `Оценка: от ${$v.taskItem.answer.points.$params.between.min} до ${$v.taskItem.answer.points.$params.between.max}` : 'Оценка:'"
          :error="$v.$dirty && (!$v.taskItem.answer.points.between || !$v.taskItem.answer.points.required)"
          :placeholder="`от ${taskItem.question.minPoints} до ${taskItem.question.maxPoints}`"
        )

      slot(name="edit")

    .answers-card__footer.margin-top__15(v-else)
      .answers-card__review
        .answers-card__review-row
          .answers-card__reviewer
            .answers-card__reviewer-person
              .answers-card__person
                Avatar(:img="validatorAvatar" circle size="s")
                .lesson-block__person-name
                  | {{validatorName}}

          .answers-card__rating
            p.main-block__label
              | Оценка:
              span.color(v-if="!afterDdl || taskItem.answer.points")
                |  {{points}}
              span.color(v-else)
                |  {{pointAfterDdl}}


        ToggleTextBlock.main-block__text.answers-card__text(
          :text="validatingText ? validatingText : 'Проверяющий не оставил комментария'"
        )
    Comment( :value="taskItem.answer.comments" :task="taskItem" )
</template>

<script>
import _ from 'lodash';
import Info from './Info';
import Comment from '../../Comments';
import ToggleTextBlock from '@/components/Form/ToggleTextBlock';
import { required, between } from 'vuelidate/lib/validators';
import moment from 'moment-timezone';
import textToHtmlWithLinks from '@/functions/textToHTMLWithLikns';
moment.locale('ru');

export default {
  components: { Info, ToggleTextBlock, Comment },
  props: {
    propTaskItem: {},
    scripts: {},
    ddl: {},
    touch: {},
    systemName: {},
    ddlDateString: {},
    answerCreatedAt: {},
    isOpen: {
      type: Boolean,
      default: false
    },
    userInfo: {}
  },
  data: () => ({
    taskItem: {
      answer: {
        files: [],
        points: '',
        validatingText: ''
      },
      question: {
        typeOfTask: ''
      }
    },
    script: ''
  }),
  computed: {
    selectScriptData() {
      if (this.scripts.length > 0) {
        return [
          {
            id: 'scriptId',
            text: 'Выберите скрипт',
            value: ''
          },
          ...this.scripts.map(el => {
            return { ...el, value: el.text };
          })
        ];
      } else {
        return [
          {
            id: 'scriptId',
            text: 'Выберите скрипт',
            value: ''
          }
        ];
      }
    },
    ddlDate() {
      return moment
        .tz(this.ddl, 'Europe/Moscow')
        .format('DD.MM.YYYY в HH:mm:ss');
    },
    afterDdl() {
      const ddl = moment
        .tz(this.ddl, 'Europe/Moscow')
        .format('DD.MM.YYYY HH:mm:ss');
      const current = moment()
        .tz('Europe/Moscow')
        .format('DD.MM.YYYY HH:mm:ss');

      return current > ddl;
    },
    validatingText() {
      return this.taskItem.answer.validatingText
        ? textToHtmlWithLinks(this.taskItem.answer.validatingText)
        : '';
    },
    validatorName() {
      return this.taskItem.answer.validatorName
        ? this.taskItem.answer.validatorName
        : '';
    },
    validatorAvatar() {
      return this.taskItem.answer.validatorAvatar
        ? this.taskItem.answer.validatorAvatar
        : '';
    },
    pointAfterDdl() {
      return this.taskItem.question.pointsAfterDdl;
    },
    points() {
      const item = this.taskItem.answer.points !== undefined;
      if (item) {
        return this.taskItem.answer.points;
      } else if (this.sentAndAutoCheck) {
        const createdAt = moment.tz(
          this.taskItem.answer.createdAt,
          'Europe/Moscow'
        );
        let beforeDDL = true;
        if (this.ddlDate) {
          beforeDDL = createdAt.format() < this.ddlDate.format();
        }

        return beforeDDL
          ? this.taskItem.question.pointsBeforeDdl
          : this.taskItem.question.pointsAfterDdl;
      } else {
        return '';
      }
    },
    sentAndAutoCheck() {
      if (this.taskItem) {
        return false;
      }

      return this.taskItem.answer.id && this.taskItem.question.isAutoCheck;
    }
  },
  watch: {
    propTaskItem: {
      deep: true,
      handler() {
        const data = _.cloneDeep(this.propTaskItem);
        if (!this.propTaskItem.answer.validatingText) {
          data.answer.validatingText += this.userInfo.name + ', ';
        } else {
          let nameLength = this.userInfo.name.split('');
          nameLength = nameLength.length;
          const firstWords = this.propTaskItem.answer.validatingText.slice(
            0,
            nameLength + 2
          );
          if (!firstWords.includes(this.userInfo.name)) {
            data.answer.validatingText =
              this.userInfo.name +
              ', ' +
              this.propTaskItem.answer.validatingText;
          }
        }

        this.taskItem = _.cloneDeep(data);
      }
    },
    taskItem: {
      deep: true,
      handler() {
        this.emitData();
      }
    },
    script() {
      this.emitData();
    },
    touch() {
      this.$v.$touch();
    }
  },
  mounted() {
    const data = _.cloneDeep(this.propTaskItem);
    if (!this.propTaskItem.answer.validatingText) {
      data.answer.validatingText += this.userInfo.name + ', ';
    } else {
      let nameLength = this.userInfo.name.split('');
      nameLength = nameLength.length;
      const firstWords = this.propTaskItem.answer.validatingText.slice(
        0,
        nameLength + 2
      );
      if (!firstWords.includes(this.userInfo.name)) {
        data.answer.validatingText =
          this.userInfo.name + ', ' + this.propTaskItem.answer.validatingText;
      }
    }

    this.taskItem = _.cloneDeep(data);
  },
  methods: {
    emitData() {
      const taskCopy = _.cloneDeep(this.taskItem);
      this.addScript(taskCopy);
      this.$emit(
        'hasErrors',
        this.$v.$invalid || !taskCopy.answer.validatingText
      );
      this.$emit('updateTaskItem', taskCopy);
    },
    setFixed(confirm) {
      this.taskItem.answer.points = confirm
        ? this.taskItem.question.pointsBeforeDdl
        : this.taskItem.question.pointsAfterDdl;
    },
    addScript(taskItem) {
      if (!this.script) {
        return;
      }

      if (!taskItem.answer.validatingText) {
        return (taskItem.answer.validatingText = this.script);
      }
      // если есть точка в конце
      if (/\.$/.test(taskItem.answer.validatingText)) {
        taskItem.answer.validatingText += ' ' + this.script;
      } else {
        taskItem.answer.validatingText += '. ' + this.script;
      }
    }
  },
  validations() {
    if (this.taskItem.question.typeOfTask === 2) {
      return {
        taskItem: {
          answer: {
            points: {
              required,
              between: between(
                this.taskItem.question.minPoints,
                this.taskItem.question.maxPoints
              )
            }
          }
        }
      };
    } else {
      return {
        taskItem: {
          answer: {
            points: {
              required
            }
          }
        }
      };
    }
  }
};
</script>
